import type { PortalToolName } from '@terra/shared-dto-chat-types';
import type { ToolConfig } from '../../tool-config-types';
import { createPortalToolCardRenderer } from './portal-tool-card-renderer';
import { createPortalToolResultRenderer } from './portal-tool-output-renderer';
import { createPortalToolPayloadFormatterForConfig } from './portal-tool-payload-formatter';
import { createPortalToolDisplayInputFormatter } from '@terra/shared-dto-chat-types';
import { PORTAL_TOOL_DISPLAY_CONFIG } from './portal-tool-display-config';

export function createPortalToolConfig(toolName: PortalToolName): ToolConfig {
  const displayConfig = PORTAL_TOOL_DISPLAY_CONFIG[toolName];
  if (!displayConfig) {
    throw new Error(`Missing portal tool display config for ${toolName}`);
  }

  return {
    name: displayConfig.label,
    icon: displayConfig.icon,
    category: 'executable',
    cardType: 'minimal',
    runningText: displayConfig.runningText,
    renderCard: createPortalToolCardRenderer(toolName),
    renderOutput: createPortalToolResultRenderer(toolName),
    formatPayload: createPortalToolPayloadFormatterForConfig(toolName),
    getDisplayInput: createPortalToolDisplayInputFormatter(toolName),
  };
}
